(function () {
  'use strict';

  if (customElements.get('press-quotes')) return;

  // Logos are tabs for the quotes. Autoplay has no timer: the active logo's progress bar is a CSS
  // animation (paused on hover, focus, off screen and for reduced motion) and its end advances
  // to the next quote.
  class PressQuotes extends HTMLElement {
    connectedCallback() {
      if (this.isConnectedController) return;
      this.isConnectedController = true;
      this.logos = Array.from(this.querySelectorAll('[data-press-logo]'));
      this.quotes = Array.from(this.querySelectorAll('[data-press-quote]'));
      this.activeIndex = 0;
      this.toggleAttribute('data-autoplaying', this.dataset.autoplay === 'true' && this.logos.length > 1);

      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleProgressEnd = this.handleProgressEnd.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      this.addEventListener('animationend', this.handleProgressEnd);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      this.removeEventListener('animationend', this.handleProgressEnd);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.isConnectedController = false;
    }

    handleClick(event) {
      var logo = event.target.closest('[data-press-logo]');
      if (logo) this.setActive(parseInt(logo.dataset.pressLogo, 10));
    }

    handleKeydown(event) {
      if (!event.target.closest('[data-press-logo]')) return;
      var step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
      if (!step) return;
      event.preventDefault();
      var next = (this.activeIndex + step + this.logos.length) % this.logos.length;
      this.setActive(next);
      this.logos[next].focus();
    }

    handleProgressEnd(event) {
      if (!event.target.classList.contains('press-quotes__progress')) return;
      this.setActive((this.activeIndex + 1) % this.logos.length);
    }

    handleBlockSelect(event) {
      var logo = this.querySelector('[data-shopify-editor-block*="' + event.detail.blockId + '"]');
      if (logo) this.setActive(parseInt(logo.dataset.pressLogo, 10));
    }

    setActive(index) {
      if (!Number.isFinite(index) || index === this.activeIndex) return;
      this.activeIndex = index;
      this.logos.forEach(function (logo, i) {
        var active = i === index;
        logo.classList.toggle('is-active', active);
        logo.setAttribute('aria-selected', active ? 'true' : 'false');
        logo.tabIndex = active ? 0 : -1;
      });
      this.quotes.forEach(function (quote, i) {
        var active = i === index;
        quote.classList.toggle('is-active', active);
        quote.hidden = !active;
      });
    }
  }

  customElements.define('press-quotes', PressQuotes);
})();
